import i18n from '@/i18n'

export const SCOPE_OPTIONS = [
  { value: 'NATIONAL', label: i18n.t('NATIONAL') },
  { value: 'LOCAL', label: i18n.t('LOCAL') }
]

export const CAMPAIGN_STATUSES = {
  DRAFT: 'DRAFT',
  AGENCY_PROVISIONING: 'AGENCY_PROVISIONING',
  CENTRAL_READY: 'CENTRAL_READY',
  DIRECTOR_ACCEPTED: 'DIRECTOR_ACCEPTED',
  DIRECTOR_REJECTED: 'DIRECTOR_REJECTED',
  CENTRAL_ACCEPTED: 'CENTRAL_ACCEPTED',
  CENTRAL_REJECTED: 'CENTRAL_REJECTED',
  AGENCY_CONFIRMED: 'AGENCY_CONFIRMED',
  ACTIVE: 'ACTIVE',
  FINISHED: 'FINISHED'
}

export const CAMPAIGN_STATUS_LABELS = {
  DRAFT: i18n.t('STATUS_LABEL_DRAFT'),
  AGENCY_PROVISIONING: i18n.t('STATUS_LABEL_AGENCY_PROVISIONING'),
  CENTRAL_READY: i18n.t('STATUS_LABEL_CENTRAL_READY'),
  DIRECTOR_ACCEPTED: i18n.t('STATUS_LABEL_DIRECTOR_ACCEPTED'),
  DIRECTOR_REJECTED: i18n.t('STATUS_LABEL_DIRECTOR_REJECTED'),
  CENTRAL_ACCEPTED: i18n.t('STATUS_LABEL_CENTRAL_ACCEPTED'),
  CENTRAL_REJECTED: i18n.t('STATUS_LABEL_CENTRAL_REJECTED'),
  AGENCY_CONFIRMED: i18n.t('STATUS_LABEL_AGENCY_CONFIRMED'),
  ACTIVE: i18n.t('STATUS_LABEL_ACTIVE'),
  FINISHED: i18n.t('STATUS_LABEL_FINISHED')
}

export const CAMPAIGN_CTAS = {
  'BECOME_A_VOLUNTEER': 'BECOME_A_VOLUNTEER',
  // 'BOOK_APPOINTMENT': 'BOOK_APPOINTMENT',
  'BOOK_NOW': 'BOOK_NOW',
  'BUY_TICKETS': 'BUY_TICKETS',
  'CALL_NOW': 'CALL_NOW',
  'CHARITY_DONATE': 'CHARITY_DONATE',
  'CONTACT_US': 'CONTACT_US',
  'DONATE_NOW': 'DONATE_NOW',
  'EMAIL': 'EMAIL',
  'FOLLOW_PAGE': 'FOLLOW_PAGE',
  'GET_DIRECTIONS': 'GET_DIRECTIONS',
  'GET_OFFER': 'GET_OFFER',
  'GET_OFFER_VIEW': 'GET_OFFER_VIEW',
  'INTERESTED': 'INTERESTED',
  'LEARN_MORE': 'LEARN_MORE',
  'LISTEN': 'LISTEN',
  'LOCAL_DEV_PLATFORM': 'LOCAL_DEV_PLATFORM',
  // 'MESSAGE': 'MESSAGE',
  // 'MOBILE_CENTER': 'MOBILE_CENTER',
  'OPEN_APP': 'OPEN_APP',
  'ORDER_FOOD': 'ORDER_FOOD',
  'PLAY_MUSIC': 'PLAY_MUSIC',
  'PLAY_NOW': 'PLAY_NOW',
  'PURCHASE_GIFT_CARDS': 'PURCHASE_GIFT_CARDS',
  'REQUEST_APPOINTMENT': 'REQUEST_APPOINTMENT',
  'REQUEST_QUOTE': 'REQUEST_QUOTE',
  'SHOP_NOW': 'SHOP_NOW',
  'SHOP_ON_FACEBOOK': 'SHOP_ON_FACEBOOK',
  'SIGN_UP': 'SIGN_UP',
  'VIEW_INVENTORY': 'VIEW_INVENTORY',
  'VIEW_MENU': 'VIEW_MENU',
  'VIEW_SHOP': 'VIEW_SHOP',
  'VISIT_GROUP': 'VISIT_GROUP',
  'WATCH_NOW': 'WATCH_NOW',
  'WOODHENGE_SUPPORT': 'WOODHENGE_SUPPORT'
}

export const CAMPAIGN_CTA_LABELS = {
  'BECOME_A_VOLUNTEER': i18n.t('BECOME_A_VOLUNTEER'),
  'BOOK_APPOINTMENT': i18n.t('BOOK_APPOINTMENT'),
  'BOOK_NOW': i18n.t('BOOK_NOW'),
  'BUY_TICKETS': i18n.t('BUY_TICKETS'),
  'CALL_NOW': i18n.t('CALL_NOW'),
  'CHARITY_DONATE': i18n.t('CHARITY_DONATE'),
  'CONTACT_US': i18n.t('CONTACT_US'),
  'DONATE_NOW': i18n.t('DONATE_NOW'),
  'EMAIL': i18n.t('EMAIL'),
  'FOLLOW_PAGE': i18n.t('FOLLOW_PAGE'),
  'GET_DIRECTIONS': i18n.t('GET_DIRECTIONS'),
  'GET_OFFER': i18n.t('GET_OFFER'),
  'GET_OFFER_VIEW': i18n.t('GET_OFFER_VIEW'),
  'INTERESTED': i18n.t('INTERESTED'),
  'LEARN_MORE': i18n.t('LEARN_MORE'),
  'LISTEN': i18n.t('LISTEN'),
  'LOCAL_DEV_PLATFORM': i18n.t('LOCAL_DEV_PLATFORM'),
  'MESSAGE': i18n.t('MESSAGE'),
  'MOBILE_CENTER': i18n.t('MOBILE_CENTER'),
  'OPEN_APP': i18n.t('OPEN_APP'),
  'ORDER_FOOD': i18n.t('ORDER_FOOD'),
  'PLAY_MUSIC': i18n.t('PLAY_MUSIC'),
  'PLAY_NOW': i18n.t('PLAY_NOW'),
  'PURCHASE_GIFT_CARDS': i18n.t('PURCHASE_GIFT_CARDS'),
  'REQUEST_APPOINTMENT': i18n.t('REQUEST_APPOINTMENT'),
  'REQUEST_QUOTE': i18n.t('REQUEST_QUOTE'),
  'SHOP_NOW': i18n.t('SHOP_NOW'),
  'SHOP_ON_FACEBOOK': i18n.t('SHOP_ON_FACEBOOK'),
  'SIGN_UP': i18n.t('SIGN_UP'),
  'VIEW_INVENTORY': i18n.t('VIEW_INVENTORY'),
  'VIEW_MENU': i18n.t('VIEW_MENU'),
  'VIEW_SHOP': i18n.t('VIEW_SHOP'),
  'VISIT_GROUP': i18n.t('VISIT_GROUP'),
  'WATCH_NOW': i18n.t('WATCH_NOW'),
  'WOODHENGE_SUPPORT': i18n.t('WOODHENGE_SUPPORT')
}

export const GENERIC_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
}

export const CAMPAIGN_STATUS_LABELS_RESULTS = {
  ACTIVE: i18n.t('ACTIVE_CAMPAIGN'),
  FINISHED: i18n.t('FINISHED')
}

export const CAMPAIGN_STATUS_COLORS = {
  DRAFT: '#4b565f',
  AGENCY_PROVISIONING: '#7f3c8d',
  CENTRAL_READY: '#fbcf7d',
  DIRECTOR_ACCEPTED: 'rgba(118, 204, 133, 0.12)',
  DIRECTOR_REJECTED: 'rgba(255, 110, 102, 0.12)',
  CENTRAL_ACCEPTED: '#76cc85',
  CENTRAL_REJECTED: '#ff6d66',
  AGENCY_CONFIRMED: null,
  ACTIVE: '#76cc85',
  FINISHED: '#ff6d66'
}

export const CHANNEL_OPTIONS_EXTERIOR = {
  EXTERIOR: 'EXTERIOR',
  SIGNALING: 'SIGNALING'
}

export const CHANNEL_OPTIONS = {
  // ONLINE: 'ONLINE',
  // OFFLINE: 'OFFLINE',
  // VIDEO: 'VIDEO',
  // INSTAGRAM: 'INSTAGRAM',
  // FACEBOOK: 'FACEBOOK',
  // YOUTUBE: 'YOUTUBE',
  META: 'META',
  LOCALINVENTORYADS: 'LOCALINVENTORYADS',
  GOOGLESEARCHADS: 'GOOGLESEARCHADS',
  DV360: 'DV360',
  // GOOGLE: 'GOOGLE',
  GEOLOCATION: 'GEOLOCATION'
  // INTEREST: 'INTEREST',
  // RETARGETING: 'RETARGETING'
}

export const CHANNEL_COLORS = {
  ONLINE: '#442bcb',
  OFFLINE: '#eebf00',
  FACEBOOK: '#2851a3',
  META: '#2851a3',
  INSTAGRAM: '#ff0075',
  YOUTUBE: '#ff6961',
  LOCALINVENTORYADS: '#0F9D58',
  GOOGLESEARCHADS: '#F4B400',
  GEOLOCATION: '#f48300',
  DV360: '#abb989',
  GOOGLE: '#3e82f7',
  INTEREST: '#00b3bc',
  RETARGETING: '#b99400',
  VIDEO: '#ff0000',
  EXTERIOR: '#2b7d84',
  SIGNALING: '#2b7d84'
}

export const CHANNEL_LABELS = {
  ONLINE: i18n.t('CHANNEL_ONLINE'),
  OFFLINE: i18n.t('CHANNEL_OFFLINE'),
  META: i18n.t('CHANNEL_META'),
  FACEBOOK: i18n.t('CHANNEL_FACEBOOK'),
  INSTAGRAM: i18n.t('CHANNEL_INSTAGRAM'),
  YOUTUBE: i18n.t('CHANNEL_YOUTUBE'),
  LOCALINVENTORYADS: i18n.t('CHANNEL_LOCALINVENTORYADS'),
  GOOGLESEARCHADS: i18n.t('CHANNEL_GOOGLESEARCHADS'),
  DV360: i18n.t('CHANNEL_DV360'),
  GEOLOCATION: i18n.t('CHANNEL_GEOLOCATION'),
  GOOGLE: i18n.t('CHANNEL_GOOGLE'),
  INTEREST: i18n.t('CHANNEL_INTEREST'),
  RETARGETING: i18n.t('CHANNEL_RETARGETING'),
  VIDEO: i18n.t('CHANNEL_VIDEO'),
  EXTERIOR: i18n.t('CHANNEL_EXTERIOR'),
  SIGNALING: i18n.t('CHANNEL_SIGNALING')
}

export const CHANNEL_DEFAULT_KPIS = { // Only impacts and coverage are available. See file channel-card.js L:61
  GOOGLE: ['impacts']
}

export const CHANNEL_FORMATS = {
  MOBILE_BANNER: {
    key: 'MOBILE_BANNER',
    name: i18n.t('FORMAT_BANNER'),
    channels: [
      CHANNEL_OPTIONS.GEOLOCATION,
      CHANNEL_OPTIONS.RETARGETING,
      CHANNEL_OPTIONS.INTEREST
    ]
  },
  MOBILE_CARROUSEL: {
    key: 'MOBILE_CARROUSEL',
    name: i18n.t('FORMAT_CARROUSEL'),
    channels: [
      CHANNEL_OPTIONS.GEOLOCATION,
      CHANNEL_OPTIONS.RETARGETING,
      CHANNEL_OPTIONS.INTEREST
    ]
  },
  FACEBOOK_BANNER: {
    key: 'FACEBOOK_BANNER',
    name: i18n.t('FORMAT_BANNER'),
    channels: [
      CHANNEL_OPTIONS.FACEBOOK,
      CHANNEL_OPTIONS.INSTAGRAM
    ]
  },
  FACEBOOK_CARROUSEL: {
    key: 'FACEBOOK_CARROUSEL',
    name: i18n.t('FORMAT_CARROUSEL'),
    channels: [
      CHANNEL_OPTIONS.FACEBOOK,
      CHANNEL_OPTIONS.INSTAGRAM
    ]
  },
  FACEBOOK_VIDEO: {
    key: 'FACEBOOK_VIDEO',
    name: i18n.t('FORMAT_VIDEO'),
    channels: [
      CHANNEL_OPTIONS.FACEBOOK,
      CHANNEL_OPTIONS.INSTAGRAM
    ]
  },
  KEYWORDS: {
    key: 'KEYWORDS',
    name: i18n.t('FORMAT_KEYWORDS'),
    channels: [CHANNEL_OPTIONS.GOOGLE]
  }
}

export const CHANNEL_KPIS = {
  'IMPRESSIONS': 'IMPRESSIONS',
  'CLICKS': 'CLICKS',
  'CTR': 'CTR',
  'VISITS': 'VISITS'
}

export const CHANNEL_KPI_LABELS = {
  'IMPRESSIONS': i18n.t('IMPRESSIONS'),
  'CLICKS': i18n.t('CLICKS'),
  'CTR': i18n.t('CTR'),
  'VISITS': i18n.t('VISITS')
}

export const CHANNEL_PRODUCT_TYPES = {
  REDIRECT: { value: 'REDIRECT', label: i18n.t('PRODUCT') },
  DIRECT: { value: 'DIRECT', label: i18n.t('SERVICE') },
  HYBRID: { value: 'HYBRID', label: i18n.t('MIXED') }
}

export const CHANNEL_PRODUCT_PURCHASES = {
  // CPA: { value: 'CPA', label: 'CPA' },
  CPM: { value: 'CPM', label: 'CPM' },
  CPV: { value: 'CPV', label: 'CPV' }
}

export const CHANNEL_PRODUCT_YOUTUBE_DURATION = [
  { value: '<15', label: 'Bumper' },
  { value: '15_20', label: 'Unskip' },
  { value: '>20', label: 'Skip' }
]

export const CHANNEL_PRODUCT_KINDS = [
  { value: 'REDIRECT', label: i18n.t('PRODUCT') },
  { value: 'DIRECT', label: i18n.t('SERVICE') },
  { value: 'HYBRID', label: i18n.t('MIXED') }
]

export const REPORTING_GROUPS_KINDS = {
  1: `${i18n.t('Tier')} 1`,
  2: `${i18n.t('Tier')} 2`,
  3: `${i18n.t('Tier')} 3`
}

// export const CHANNEL_DIRECTION_TYPES = {
//   REDIRECT: { value: 'REDIRECT', label: 'Redirect' },
//   DIRECT: { value: 'DIRECT', label: 'Direct' }
// }

// export const CHANNEL_PRODUCT_KINDS = {
//   PRODUCT: { value: 'PRODUCT', label: 'Producto' },
//   SERVICE: { value: 'SERVICE', label: 'Servicio' }
// }

// export const CREATIVITY_TYPES = {
//   WEBORAMA: { value: 'WEBORAMA', label: 'Weborama' },
//   CUSTOM: { value: 'CUSTOM', label: 'Custom' }
// }

export const CREATIVITY_FORMATS = {
  BANNER: { name: i18n.t('FORMAT_BANNER'), id: 'banner', size: '320x50' },
  INTERSITIAL: { name: i18n.t('FORMAT_INTERSITIAL'), id: 'interstitial', size: '320x480' },
  MEDIUM_BANNER: { name: i18n.t('FORMAT_MEDIUM_BANNER'), id: 'mediumBanner', size: '300x250' },
  HALF_PAGE: { name: i18n.t('FORMAT_HALF_PAGE'), id: 'halfPage', size: '300x600' },
  BANNER_TABLET: { name: i18n.t('FORMAT_BANNER_TABLET'), id: 'bannerTablet', size: '728x90' },
  SUPER_LEADERBOARD: { name: i18n.t('FORMAT_SUPER_LEADERBOARD'), id: 'superLeaderboard', size: '970x90' },
  MEGASKYSCRAPER: { name: i18n.t('FORMAT_MEGASKYSCRAPER'), id: 'skyscraper160', size: '160x600' },
  SKYSCRAPER: { name: i18n.t('FORMAT_SKYSCRAPER'), id: 'skyscraper', size: '120x600' },
  BILLBOARD: { name: i18n.t('FORMAT_BILLBOARD'), id: 'billboard', size: '970x250' },
  INTERSTITIAL_DESKTOP: { name: i18n.t('FORMAT_INTERSTITIAL_DESKTOP'), id: 'interstitialDesktop', size: '1200x900' },
  VIDEO: { name: i18n.t('FORMAT_VIDEO'), id: 'video' }
}

export const HYBRID_CREATIVITY_FORMATS = {
  INTERSITIAL: { name: i18n.t('FORMAT_INTERSITIAL'), id: 'interstitial', size: '320x480' },
  MEDIUM_BANNER: { name: i18n.t('FORMAT_MEDIUM_BANNER'), id: 'mediumBanner', size: '300x250' },
  HALF_PAGE: { name: i18n.t('FORMAT_HALF_PAGE'), id: 'halfPage', size: '300x600' },
  BANNER_TABLET: { name: i18n.t('FORMAT_BANNER_TABLET'), id: 'bannerTablet', size: '728x90' },
  MEGASKYSCRAPER: { name: i18n.t('FORMAT_MEGASKYSCRAPER'), id: 'skyscraper160', size: '160x600' }
}

export const FB_BANNER = { name: i18n.t('FORMAT_BANNER'), id: 'banner', size: '1080x1080' }
export const FB_BANNER_TO_UPLOAD = { name: i18n.t('FORMAT_BANNER'), id: 'bannerFacebook', size: '1080x1080' }

export const FB_CREATIVITY_FORMATS = {
  FORMAT1: { name: i18n.t('FORMAT_BANNER'), id: 'banner', size: '600x600' },
  FORMAT2: { name: i18n.t('FORMAT_BANNER'), id: 'banner', size: '800x800' },
  FORMAT3: { name: i18n.t('FORMAT_BANNER'), id: 'banner', size: '1080x1080' }
}

export const CAMPAIGN_TYPES = {
  DIGITAL: 'DIGITAL',
  EXTERIOR: 'EXTERIOR'
}

export const CAMPAIGN_COMMENTS_LABELS = {
  REJECTED: i18n.t('COMMENT_REJECTED'),
  ACCEPTED: i18n.t('COMMENT_ACCEPTED'),
  DIRECTOR_REJECTED: i18n.t('COMMENT_DIRECTOR_REJECTED'),
  DIRECTOR_ACCEPTED: i18n.t('COMMENT_DIRECTOR_ACCEPTED'),
  CENTRAL_REJECTED: i18n.t('COMMENT_CENTRAL_REJECTED'),
  CENTRAL_ACCEPTED: i18n.t('COMMENT_CENTRAL_ACCEPTED')
}

export const TEMPLATE_UPDATE_TIME_ERROR = 'ZoneTemplate is out of update'

export const CHANNEL_DV360_OPTIONS = {
  CREATE_UPDATE: { value: 'CREATE_UPDATE', label: i18n.t('CREATE_UPDATE'), disabled: false },
  ADD_LINE_ITEM: { value: 'ADD_LINE_ITEM', label: i18n.t('ADD_NEW_LINE_ITEM'), disabled: false }
}

export const CHANNEL_FB_OPTIONS = {
  CREATE_UPDATE: { value: 'CREATE_UPDATE', label: i18n.t('CREATE_UPDATE'), disabled: false },
  ADD_AD_SET: { value: 'ADD_AD_SET', label: i18n.t('ADD_NEW_AD_SET'), disabled: false }
}
